export default "/images/bce52ea72eb27f024c112aef6b36453f.avif";